import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import {
  APPLICATION_UPDATE_ANDROID_PATH,
  APPLICATION_UPDATE_IOS_PATH,
} from "utils/constants/paths";

const ApplicationUpdate = Loadable(React.lazy(() => import("./View")));

export const ApplicationUpdateRoute: IRouteItem = {
  path: "/config/application-update",
  iconName: "Mobile",
  element: "",
  name: "Application Update",
  accessKeys: ["SuperAdmin", "Admin"],
  children: [
    {
      path: APPLICATION_UPDATE_ANDROID_PATH,
      iconName: "Android",
      element: React.createElement(ApplicationUpdate),
      name: "Android",
    },
    {
      path: APPLICATION_UPDATE_IOS_PATH,
      iconName: "Apple",
      element: React.createElement(ApplicationUpdate),
      name: "IOS",
    },
  ],
};
